import { useEffect } from 'react';
import { useParams } from 'react-router';
import { store as ratingsStore } from '../state/use-ratings/store';
import { store as commentsStore } from '../state/use-comments/store';
import { store as candidatesStore } from '../state/use-candidates/store';
import { store as openCallStore } from '../state/use-open-calls/store';

export function useResetStores() {
  const { openCallId } = useParams();

  useEffect(() => {
    // Reset all stores when openCallId changes
    ratingsStore.getState().reset();
    commentsStore.getState().reset();
    candidatesStore.getState().reset();
    openCallStore.getState().reset();

    if (openCallId) {
      // Setting the new openCallId in the candidates store
      candidatesStore.setState({
        params: {
          ...candidatesStore.getState().params,
          filters: {
            ...candidatesStore.getState().params.filters,
            openCallId,
          },
        },
      });
    }
  }, [openCallId]);
}
